// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"Layout__PageWrapper___2PRaL","DisableBgdScroll":"Layout__DisableBgdScroll___3kDLX","ContentWrapper":"Layout__ContentWrapper___80XwG"};